import { connect } from "react-redux";
import { Action, bindActionCreators, Dispatch } from "redux";

import {
  IPatchCourseAction,
  patchCourseChooseSingleChoiceAnswerRequest as chooseSingleChoiceAnswer,
  sortPartRequest,
} from "../../../../../../actions/course-author/common";
import { ChoicesComponent } from "./Choices.component";
import { IChoicesDispatchProps } from "./Choices.types";

const mapDispatchToProps = (dispatch: Dispatch<Action<IPatchCourseAction>>): IChoicesDispatchProps =>
  bindActionCreators({ chooseSingleChoiceAnswer, sortPartRequest }, dispatch);

export const Choices = connect(null, mapDispatchToProps)(ChoicesComponent);
